
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaFronteiras: [],
	listaNegociadores: [],
	listaRumos: [{ id: 'RN', valor: 'Rumo Norte' }, { id: 'RS', valor: 'Rumo Sul' }, { id: 'NAC', valor: 'Nacional' }],
	listaOperacoes: [],
	aguardando: false,
	filtro: {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'REPORTS_INCONFORMIDADE_HISTORICO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'REPORTS_INCONFORMIDADE_HISTORICO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

		case 'REPORTS_INCONFORMIDADE_HISTORICO_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

        case 'REPORTS_INCONFORMIDADE_HISTORICO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
		

		case 'REPORTS_INCONFORMIDADE_HISTORICO_FRONTEIRA_LISTADO':
			return {
				...state,
				listaFronteiras: action.payload.data || []
			};

		case 'REPORTS_INCONFORMIDADE_HISTORICO_NEGOCIADOR_LISTADO':
			return {
				...state,
				listaNegociadores: action.payload.data || []
			};

		case 'REPORTS_INCONFORMIDADE_HISTORICO_OPERACAO_LISTADO':
			return {
				...state,
				listaOperacoes: (action.payload.data || []).filter(item => item.id != 575) //EXCECAO_GERAL
			};
		
        default:
            return state;
    }
}
